import {combineReducers} from 'redux'
import api from './api'
import config from './config'

export default combineReducers({
    api,
    config
})
